import { render, staticRenderFns } from "./CompleteAccount.vue?vue&type=template&id=883ca2d4&scoped=true"
import script from "./CompleteAccount.vue?vue&type=script&lang=ts"
export * from "./CompleteAccount.vue?vue&type=script&lang=ts"
import style0 from "./CompleteAccount.vue?vue&type=style&index=0&id=883ca2d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883ca2d4",
  null
  
)

export default component.exports